import * as angular from 'angular';
import * as _ from 'lodash';

import { guidEmpty } from '../../common/constants';
import { IGroupService, IIdentifierVmService } from '../../services';
import { Group, IValueViewModel, Identifier, ComponentDefinition } from '../../models';

class IdentifierSelectController implements angular.IComponentController {
    groupGuid: string;
    identifier: Identifier;
    selectedGuid: string;
    guidEmpty: string = guidEmpty;
    allGroups: { [guid: string]: Group } = {};
    viewModels: { [guid: string]: IValueViewModel } = {};
    hasNoGroup: boolean;
    onChange?: () => void;
    static $inject = ['$q', 'groupService', 'identifierVmService'];
    //private _valueViewModels: { [guid: string]: IvalueViewModel };

    constructor(private _$q: angular.IQService,
        private _groupService: IGroupService,
        private _identifierVmService: IIdentifierVmService) { }

    $onInit() {
        this._$q.all([
            this._groupService.getAllAsTreeOrdered(),
            this._identifierVmService.getAllViewModels()
        ]).then(responses => {
            responses[0].forEach(group => this.allGroups[group.guid] = group);
            responses[1].forEach(d => this.viewModels[d.guid] = d);
            this.refreshViewModels();
        }).catch(reason => {
            this.groupGuid = guidEmpty;
        });
    }

    $onChanges(changesObj) {
        this.identifier = null;
        this.refreshViewModels();
    }

    onSelect() {
        if (this.onChange) {
            this.onChange();
        }
    }

    private refreshViewModels() {
        this.hasNoGroup = !this.groupGuid
            || this.groupGuid === guidEmpty
            || !this.allGroups[this.groupGuid]
            || this.allGroups[this.groupGuid].identifierCollection.length === 0;

        if (this.groupGuid && this.groupGuid !== guidEmpty) {
            const group = this.allGroups[this.groupGuid];
            if (group) {
                this.identifier = _.find(group.identifierCollection, i => i.guid === this.selectedGuid);
                //this.il = group.identifierCollection.map(i => this._valueViewModels[i.guid]);
            }
        }
    }
}

export const wtIdentifierSelect: ComponentDefinition = {
    componentId: 'wtIdentifierSelect',
    controller: IdentifierSelectController,
    controllerAs: 'vm',
    template: require('./identifierSelect.component.html'),
    bindings: {
        groupGuid: '<',
        selectedGuid: '<?',
        identifier: '=?',
        onChange: '&?',
        isDisabled: '<?'
    }
};